import { Component, OnInit, ViewChild, Input, EventEmitter, Output } from '@angular/core';

import { Observable, Subscription } from 'rxjs';
import { tap } from "rxjs/operators";
import { FinancialAssuranceSummary, FinancialStatement } from '../../../../models/financialAssurance.model';
import { FinancialAssuranceService } from '../../../../services/financial-assurance.service';
import { Organization, OrganizationComplianceDetails } from '../../../../models/organization.model';
import { FinancialAssuranceBondingComponent } from '../../../financial-assurance/fa-bonding.component';
import { FinancialAssuranceInsuranceComponent } from '../../../financial-assurance/fa-insurance.component';
import { FinancialAssurancePendingComponent } from '../../../financial-assurance/fa-pending.component';
import { FinancialAssuranceNotSubmittedFlowComponent } from '../../../financial-assurance/fa-not-submitted-flow.component';
import { OrganizationService } from "../../../../services/organization.service";

@Component({
    selector: 'organization-financial-assurance',
    templateUrl: './organization-financial-assurance.component.html',
    standalone: false
})

export class OrganizationFinancialAssuranceComponent implements OnInit {

    @ViewChild(FinancialAssuranceBondingComponent, { static: true }) public _bondingGrid: FinancialAssuranceBondingComponent;
    @ViewChild(FinancialAssuranceInsuranceComponent, { static: true }) public _insuranceGrid: FinancialAssuranceInsuranceComponent;
    @ViewChild(FinancialAssurancePendingComponent, { static: true }) public _pendingGrid: FinancialAssurancePendingComponent;
    @ViewChild(FinancialAssuranceNotSubmittedFlowComponent, { static: true }) public _notSubmittedGrid: FinancialAssuranceNotSubmittedFlowComponent;

    _isRecalculating: boolean = false;

    get isRecalculating(): boolean {
        return this._isRecalculating;
    }

    @Input() set isRecalculating(value: boolean) {
        this._isRecalculating = value;
    }

    _isLoading: boolean = true;

    get isLoading(): boolean {
        return this._isLoading;
    }

    @Input() set isLoading(value: boolean) {
        this._isLoading = value;
    }

    @Input() organization: Organization;

    private _complianceDetails: OrganizationComplianceDetails;

    get complianceDetails(): OrganizationComplianceDetails {
        return this._complianceDetails;
    }

    @Input() set complianceDetails(detail: OrganizationComplianceDetails) {
        this._complianceDetails = detail;
    }


    subscriptions: Subscription = new Subscription();
    orgId: string;
    activeFinancialStatement: FinancialStatement;

    @Output() recalculateEvent: EventEmitter<string> = new EventEmitter<string>();

    constructor(public service: FinancialAssuranceService, private organizationService: OrganizationService) { }

    ngOnInit() {
        this.orgId = this.organization.id;

        this.subscriptions.add(this.service.getActiveFinancialStatement(this.orgId).subscribe((activeFinancialStatement) => {
            this.activeFinancialStatement = activeFinancialStatement;
        }));
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    onTabClicked(): void {
        if (this._bondingGrid)
            this._bondingGrid.resizeColumns();
        if (this._insuranceGrid)
            this._insuranceGrid.resizeColumns();
        if (this._notSubmittedGrid)
            this._notSubmittedGrid.resizeColumns();
        if (this._pendingGrid)
            this._pendingGrid.resizeColumns();
    }

    recalculate(organization: string): void {
        this.recalculateEvent.emit(organization);
    }
}
